var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalRiderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8122_58307)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FEF0F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8122_58307)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8122_58307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8H32C34.2091 8 36 9.79086 36 12V50H4V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 29.5508,
    width: 26.7755,
    height: 4.57143,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 26.7755,
    height: 4.57143,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61133,
    y: 35.4277,
    width: 26.7755,
    height: 16.3265,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 8.4898,
    height: 9.79592,
    rx: 1.34,
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8122_58307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 21.75H15.25V22.25H13.25V23L12 22L13.25 21V21.75ZM12.9998 23.5H13.6771C14.0297 23.8112 14.4928 24 15 24C16.1046 24 17 23.1046 17 22C17 20.8954 16.1046 20 15 20C14.4928 20 14.0297 20.1888 13.6771 20.5H12.9998C13.4559 19.8928 14.1821 19.5 15 19.5C16.3807 19.5 17.5 20.6193 17.5 22C17.5 23.3807 16.3807 24.5 15 24.5C14.1821 24.5 13.4559 24.1072 12.9998 23.5Z",
    fill: "#0EA3FD"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.4902,
    y: 17,
    width: 8.4898,
    height: 9.79592,
    rx: 1.34,
    fill: "#FEEBEE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_8122_58307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4902 19.1309C25.6283 19.1309 25.7402 19.2428 25.7402 19.3809V19.6309H26.9902V21.1309H26.4855L27.172 23.0171C27.2161 23.1298 27.2402 23.2525 27.2402 23.3809C27.2402 23.9331 26.7925 24.3809 26.2402 24.3809C25.7743 24.3809 25.3828 24.0622 25.2717 23.6309H24.2087C24.0977 24.0622 23.7062 24.3809 23.2402 24.3809C22.7541 24.3809 22.349 24.034 22.2589 23.5743C22.0992 23.4908 21.9902 23.3235 21.9902 23.1309V20.6309C21.9902 20.4928 22.1022 20.3809 22.2402 20.3809H23.9902C24.1283 20.3809 24.2402 20.4928 24.2402 20.6309V21.8809C24.2402 22.0189 24.3522 22.1309 24.4902 22.1309H24.9902C25.1283 22.1309 25.2402 22.0189 25.2402 21.8809V19.6309H24.4902V19.1309H25.4902ZM26.2402 22.8809C25.9641 22.8809 25.7402 23.1047 25.7402 23.3809C25.7402 23.657 25.9641 23.8809 26.2402 23.8809C26.5164 23.8809 26.7402 23.657 26.7402 23.3809C26.7402 23.3208 26.7296 23.2632 26.7102 23.2098L26.7061 23.199C26.6334 23.0128 26.4522 22.8809 26.2402 22.8809ZM23.2402 22.8809C22.9641 22.8809 22.7402 23.1047 22.7402 23.3809C22.7402 23.657 22.9641 23.8809 23.2402 23.8809C23.5164 23.8809 23.7402 23.657 23.7402 23.3809C23.7402 23.1047 23.5164 22.8809 23.2402 22.8809ZM23.7402 20.8809H22.4902V21.3809H23.7402V20.8809ZM26.4902 20.1309H25.7402V20.6309H26.4902V20.1309Z",
    fill: "#E60A2B"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M35.7 12.95H36V14.85H35.7V16.75H36V18.65H35.7V20.55H36V22.45H35.7V24.35H36V26.25H35.7V28.15H36V30.05H35.7V31.95H36V33.85H35.7V35.75H36V37.65H35.7V39.55H36V41.45H35.7V43.35H36V45.25H35.7V47.15H36V49.05H35.7V49.7H35V50H33V49.7H31V50H29V49.7H27V50H25V49.7H23V50H21V49.7H19V50H17V49.7H15V50H13V49.7H11V50H9V49.7H7V50H5V49.7H4.3V49.05H4V47.15H4.3V45.25H4V43.35H4.3V41.45H4V39.55H4.3V37.65H4V35.75H4.3V33.85H4V31.95H4.3V30.05H4V28.15H4.3V26.25H4V24.35H4.3V22.45H4V20.55H4.3V18.65H4V16.75H4.3V14.85H4V12.95H4.3V12C4.3 11.7525 4.32426 11.511 4.37043 11.2776L4.07614 11.2194C4.17995 10.6946 4.38642 10.2067 4.67374 9.77754L4.92303 9.94443C5.19325 9.54081 5.54081 9.19325 5.94443 8.92303L5.77754 8.67374C6.2067 8.38642 6.69457 8.17995 7.21935 8.07614L7.27757 8.37043C7.51098 8.32426 7.75251 8.3 8 8.3H9V8H11V8.3H13V8H15V8.3H17V8H19V8.3H21V8H23V8.3H25V8H27V8.3H29V8H31V8.3H32C32.2475 8.3 32.489 8.32426 32.7224 8.37043L32.7806 8.07614C33.3054 8.17995 33.7933 8.38642 34.2225 8.67374L34.0556 8.92303C34.4592 9.19325 34.8068 9.54081 35.077 9.94443L35.3263 9.77754C35.6136 10.2067 35.82 10.6946 35.9239 11.2194L35.6296 11.2776C35.6757 11.511 35.7 11.7525 35.7 12V12.95Z",
    stroke: "#FCB6C0",
    strokeWidth: 0.6,
    strokeDasharray: "2 2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#FCB6C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8122_58307",
    x: -2.53061,
    y: 4.08163,
    width: 45.0612,
    height: 55.0612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8122_58307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8122_58307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8122_58307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8122_58307"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8H32C34.2091 8 36 9.79086 36 12V50H4V12Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8122_58307"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19,
    width: 6,
    height: 6,
    rx: 1.34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_8122_58307"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.4902,
    y: 19,
    width: 6,
    height: 6,
    rx: 1.34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalRiderIcon);
export default __webpack_public_path__ + "static/media/external-rider-icon.c88f0babe64c66df11cca08aea7dac11.svg";
export { ForwardRef as ReactComponent };